import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0099ca6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sinc.Prefeitura", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nova", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  style: {"height":"calc(100% - 60px)"},
  class: "ss-card ss-card-space ss-tela-conteudo-completo"
}
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS:")
], -1))
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-13" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "PERÍODO:")
], -1))
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_16 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = { class: "ss-acoes-massa" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Baixar PDF(s)")
], -1))
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Baixar XML(s)")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_card = _resolveComponent("card")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_kanban = _resolveComponent("kanban")!
  const _component_nota_fiscal_servico_listagem = _resolveComponent("nota-fiscal-servico-listagem")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_nota_fiscal_servico_modal = _resolveComponent("nota-fiscal-servico-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_enviar_email_pessoa_modal = _resolveComponent("enviar-email-pessoa-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.telaBase.identificadorRecurso,
          tituloRecurso: "Notas Fiscais de Serviço",
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: [_ctx.state.empresaSelecionada]
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                ((_ctx.state.sincronizarProcessamento))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "ant-btn ss-btn-tela",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sincronizarProcessamentoComPrefeitura && _ctx.sincronizarProcessamentoComPrefeitura(...args)))
                    }, _hoisted_7))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-primary ss-btn-tela",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.incluir && _ctx.incluir(...args)))
                }, _hoisted_9)
              ])
            ])
          ]),
          _: 1
        }, 8, ["identificadorRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_card, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_select, {
                    value: _ctx.state.empresaSelecionada,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.empresaSelecionada) = $event)),
                    options: _ctx.telaBase.empresasDisponiveis,
                    style: {"width":"100%"},
                    optionFilterProp: "label",
                    onChange: _ctx.atualizarSelecaoEmpresas,
                    disabled: _ctx.telaBase.empresasDisponiveis.length === 1
                  }, null, 8, ["value", "options", "onChange", "disabled"])
                ]),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
                    valor: _ctx.state.filtroPeriodo,
                    "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.filtroPeriodo) = $event)),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.periodoAlterado()))
                  }, null, 8, ["valor"]),
                  ((_ctx.state.filtroPeriodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_a_form_item, {
                            label: "Data Inicial e Final",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data_inicial_final, {
                                dataInicialSelecionada: _ctx.state.dataInicialSelecionada,
                                "onUpdate:dataInicialSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.dataInicialSelecionada) = $event)),
                                dataFinalSelecionada: _ctx.state.dataFinalSelecionada,
                                "onUpdate:dataFinalSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.dataFinalSelecionada) = $event))
                              }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_busca_geral, {
                empresas: [_ctx.state.empresaSelecionada],
                ordenacao: _ctx.telaBase.ordenacaoSelecionada,
                "onUpdate:ordenacao": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                buscaRapida: _ctx.state.buscaRapida,
                "onUpdate:buscaRapida": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                buscaAvancada: _ctx.state.buscaAvancada,
                "onUpdate:buscaAvancada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.buscaAvancada) = $event)),
                onBuscarDados: _ctx.buscarNotasServicos
              }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados"])
            ]),
            _: 1
          }),
          _createVNode(_component_card, { style: {"height":"calc(100vh - 225px)","margin-bottom":"0px"} }, {
            default: _withCtx(() => [
              (_ctx.state.visualizarKanban)
                ? (_openBlock(), _createBlock(_component_kanban, {
                    key: 0,
                    titulo: "",
                    style: {"height":"calc(100vh - 270px)"},
                    switchListagem: true,
                    colunas: _ctx.state.colunas,
                    "onUpdate:colunas": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.colunas) = $event)),
                    visualizacaoKanban: _ctx.state.visualizarKanban,
                    "onUpdate:visualizacaoKanban": [
                      _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.visualizarKanban) = $event)),
                      _ctx.buscarNotasServicos
                    ],
                    onClickVisualizar: _ctx.clickEditar,
                    onColunaCardAlterada: _ctx.acaoDesabilitada,
                    onSelecaoCardAlterada: _ctx.selecionarCard,
                    onIdentificadoresSelecionados: _ctx.atualizarSelecionadosEmMassa,
                    onQtdSelecaoAlterada: _ctx.atualizarSelecionados,
                    onOrdemCardsAlterada: _ctx.atualizarOrdemCards
                  }, {
                    menus: _withCtx(() => [
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clickEditar && _ctx.clickEditar(...args)))
                          }, "Visualizar")
                        ]),
                        _: 1
                      }),
                      (_ctx.verificaVisualizarDFe(_ctx.state.cardSelecionado))
                        ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.visualizarDFe(_ctx.state.cardSelecionado)))
                              }, "Visualizar NFS-e")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.verificaVisualizarDFe(_ctx.state.cardSelecionado))
                        ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 1 }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.apresentarEnvioEmail(_ctx.state.cardSelecionado)))
                              }, "Enviar E-mail")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.verificaEmissao(_ctx.state.cardSelecionado))
                        ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 2 }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emitirNfse(_ctx.state.cardSelecionado)))
                              }, "Emitir NFS-e")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["colunas", "visualizacaoKanban", "onClickVisualizar", "onColunaCardAlterada", "onSelecaoCardAlterada", "onIdentificadoresSelecionados", "onQtdSelecaoAlterada", "onOrdemCardsAlterada", "onUpdate:visualizacaoKanban"]))
                : (_openBlock(), _createBlock(_component_nota_fiscal_servico_listagem, {
                    key: 1,
                    notasServicos: _ctx.state.notasServicos,
                    "onUpdate:notasServicos": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.notasServicos) = $event)),
                    paginacao: _ctx.state.paginacao,
                    "onUpdate:paginacao": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.paginacao) = $event)),
                    visualizacaoKanban: _ctx.state.visualizarKanban,
                    "onUpdate:visualizacaoKanban": [
                      _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.visualizarKanban) = $event)),
                      _ctx.buscarNotasServicos
                    ],
                    selecionados: _ctx.state.selecionados,
                    "onUpdate:selecionados": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.selecionados) = $event)),
                    onVisualizar: _ctx.editar,
                    onNovoLancamento: _ctx.incluir,
                    onBuscarNotasServicos: _ctx.buscarNotasServicos,
                    onSelecaoAlterada: _ctx.atualizarSelecionadosKanban,
                    onImprimir: _ctx.imprimirDetalhado
                  }, null, 8, ["notasServicos", "paginacao", "visualizacaoKanban", "selecionados", "onVisualizar", "onNovoLancamento", "onBuscarNotasServicos", "onSelecaoAlterada", "onUpdate:visualizacaoKanban", "onImprimir"]))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    ((_ctx.state.qtdSelecionadosAutorizadas > 0))
      ? (_openBlock(), _createBlock(_component_card, {
          key: 0,
          class: "ss-acoes-massa-selecionados",
          style: _normalizeStyle(_ctx.storeSistema.getters.menuCollapse() ? 'width: calc(100% - 60px);' : 'width: calc(100% - 210px);'),
          titulo: "Ações em massa"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.textoCodigosSelecionados()), 1),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", {
                title: "Baixar PDF(s)",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.baixarPdfs && _ctx.baixarPdfs(...args)))
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_a_badge, {
                    count: _ctx.state.qtdSelecionadosAutorizadas,
                    class: "ss-contador-nfse"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_icone, {
                        class: "ss-texto-acao-massa",
                        nome: "download"
                      })
                    ]),
                    _: 1
                  }, 8, ["count"])
                ]),
                _hoisted_20
              ]),
              _createElementVNode("a", {
                title: "Baixar XML(s)",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.baixarXmls && _ctx.baixarXmls(...args)))
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_a_badge, {
                    count: _ctx.state.qtdSelecionadosAutorizadas,
                    class: "ss-contador-nfse"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_icone, {
                        class: "ss-texto-acao-massa",
                        nome: "download"
                      })
                    ]),
                    _: 1
                  }, 8, ["count"])
                ]),
                _hoisted_22
              ])
            ])
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createVNode(_component_nota_fiscal_servico_modal, {
      operacao: _ctx.state.operacaoLancamento,
      visivel: _ctx.state.exibirLancamento,
      "onUpdate:visivel": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
      onConfirmacao: _cache[23] || (_cache[23] = ($event: any) => (_ctx.buscarNotasServicos()))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"]),
    _createVNode(_component_enviar_email_pessoa_modal, {
      visivel: _ctx.state.apresentarEnvioEmail,
      "onUpdate:visivel": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.apresentarEnvioEmail) = $event)),
      empresa: _ctx.state.empresaSelecionada,
      codigoPessoa: _ctx.state.codigoPessoaEmail,
      tituloModal: 'Confirme para quais E-mails deseja enviar a NFS-e: ' + _ctx.state.notaServicoEnvioEmail.numeroNfse,
      onEnviarEmail: _ctx.enviarEmailNFse
    }, null, 8, ["visivel", "empresa", "codigoPessoa", "tituloModal", "onEnviarEmail"])
  ]))
}